// extracted by mini-css-extract-plugin
export default {"row":"ApplicantlData_row__DiZQg","fileUpload":"ApplicantlData_fileUpload__2WErp"};